import { Procedures } from '@/types/procedure';

export const PROCEDURE_API_PATH_MAP = {
  [Procedures.INDIA]: 'identity',
  [Procedures.FRAUD]: 'fraud',
};
